import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { UtilitiesService } from '../../../../services/utilities.service';
import { TranslateService } from '@ngx-translate/core';
import { InvalidMobileErrorService } from 'src/app/services/invlid-mobile-error.service';
import { event } from 'jquery';
import { Console } from 'console';
import { EILSEQ } from 'constants';


@Component({
  selector: 'receipts-consignee-details',
  templateUrl: './consignee-details.component.html',
  styleUrls: ['./consignee-details.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({


        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class ConsigneeDetailsComponent implements OnInit, OnChanges {
  @Output() consigneeDetailsObject = new EventEmitter();
  @Input() productType
  @Input() pickUpBranches
  FilteredpickUpBranches = [] as any
  @Input() changing: boolean;
  @Input() enableChange;
  shortcoderesponse: any[]
  private _countryType: any;
  productTypeSelected: boolean;
  isOpen: boolean = true;
  consigneeDetails = {} as consignee;
  @ViewChild("AddressLine") inputEl: ElementRef;
  selectedCountry: any;
  shortCodeSettingresponse: any = []
  ShortCodemandatory: boolean = false;
  resolveRequestObj: any;
  selectedBranchId = -1;
  required = ''
  selectedBranch = {};
  @Input() countryCode;

  @Input()
  set countryType(value: any) {
    this._countryType = value;
    this.resolveRequestObj = {
      ShortCode: value
    };
  }

  @Output() isEnableSelectServices = new EventEmitter();

  focusInput() {
    this.inputEl.nativeElement.focus()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = change;
        this.consigneeDetails = { addressLine: '', attention: '', mobile: '', name: '', telephone: '', referance2: "0", email: '', consigneeReferance: '', consigneeReferance2: '', shortCode: '', shortCodeActive: false, destinationCity: '', latitude: 0, longitude: 0}
      }
    }
  }

  get countryType() {
    return this._countryType;
  }

  validatorObject = {
    mobile: {
      valid: false,
      message: ''
    },
    name: {
      valid: false,
      message: ''
    },
    attention: {
      valid: false,
      message: ''
    },
    addressLine: {
      valid: false,
      message: ''
    },
    email: {
      valid: false,
      message: ''
    },
    consigneeReferance: {
      valid: true,
      message: ''
    },
    consigneeReferance2: {
      valid: true,
      message: ''
    },
    shortCode: {
      valid: false,
      message: ''
    }
  }

  onCountrySelect(dllObject: any) {
    this.selectedCountry = dllObject;
    console.log('this is dll', dllObject);
  }

  checkRequiredField(value) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var validEmail = re.test(String(this.consigneeDetails.email).toLowerCase());
    if ((this.consigneeDetails[value] == '' || this.consigneeDetails[value] == null, this.consigneeDetails[value] == undefined) && value != 'email')
      this.validatorObject[value] = {
        valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.reqValueMsg', {
          fieldName: value
        })}`
      };
    else
      if (value == 'name') {
        if ((this.consigneeDetails['name'].trim()).length < 4) {
          this.consigneeDetails['name'] = this.consigneeDetails['name'].trim();
          this.validatorObject[value] = {
            valid: false,
            message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shortValueMsg', {
              fieldName: value
            })}`
          };
        }
        else if ((this.consigneeDetails['name'].trim()).length > 165) {
          this.consigneeDetails['name'] = this.consigneeDetails['name'].trim();
          this.validatorObject[value] = {
            valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.longValueMsg', {
              fieldName: value
            })}`
          };
        }
        else {
          this.consigneeDetails['name'] = this.consigneeDetails['name'].trim();
          this.validatorObject[value] = { valid: true, message: '' };
        }
      }
      else
        if (value == 'attention') {
          if ((this.consigneeDetails['attention'].trim()).length < 4) {
            this.consigneeDetails['attention'] = this.consigneeDetails['attention'].trim();
            this.validatorObject[value] = {
              valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shortValueMsg', {
                fieldName: value
              })}`
            };
          }
          else if ((this.consigneeDetails['attention'].trim()).length > 165) {
            this.consigneeDetails['attention'] = this.consigneeDetails['attention'].trim();
            this.validatorObject[value] = {
              valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.longValueMsg', {
                fieldName: value
              })}`
            };
          }
          else {
            this.consigneeDetails['attention'] = this.consigneeDetails['attention'].trim();
            this.validatorObject[value] = { valid: true, message: '' };
          }
        }
        else if (value === 'shortCode') {
          const code = (this.consigneeDetails.shortCode || '').trim();

          if (!code) {
            this.validatorObject[value] = {
              valid: false,
              message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant(
                'pages.createReceiptPage.errorMsgs.reqValueMsg',
                { fieldName: 'shortCode' }
              )}`
            };
          } else {
            this.validatorObject[value] = { valid: true, message: '' };
          }
        }

        else if (value == 'email') {
          if (this.consigneeDetails.email != null && this.consigneeDetails.email.trim().length > 0 && !validEmail) {
            this.validatorObject['email'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.inValidEmail')}` };
          }
          else {
            this.validatorObject['email'] = { valid: true, message: '' };
          }
        }
        else if (value == 'addressLine') {
          if ((this.consigneeDetails['addressLine'].trim()).length < 9) {
            this.consigneeDetails['addressLine'] = this.consigneeDetails['addressLine'].trim();
            this.validatorObject[value] = {
              valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.shortValueMsg', {
                fieldName: value
              })}`
            };
          }
          else if ((this.consigneeDetails['addressLine'].trim()).length > 255) {
            this.consigneeDetails['addressLine'] = this.consigneeDetails['addressLine'].trim();
            this.validatorObject[value] = {
              valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.errorMsgs.longValueMsg', {
                fieldName: value
              })}`
            };
          }
          else {
            this.consigneeDetails['addressLine'] = this.consigneeDetails['addressLine'].trim();
            this.validatorObject[value] = { valid: true, message: '' };
          }
        }
        else {
          this.consigneeDetails['addressLine'] = this.consigneeDetails['addressLine'].trim();
          this.validatorObject[value] = { valid: true, message: '' };
        }
  }
  constructor(private utilities: UtilitiesService, private translate: TranslateService, private mobileErrorService: InvalidMobileErrorService, //private _scrollToService: ScrollToService
  ) {
    this.productTypeSelected = false;
  }

  onBranchChange(e) {
    this.selectedBranchId = e.BranchId;
    this.required = ''
    this.selectedBranch = e;
    // this.selectedBranch = this.pickUpBranches.filter(x => x.BranchId == this.selectedBranchId)[0];
  }

  async fillConsigneeDetails() {
    if (this.selectedBranchId == -1) {
      this.required = '<i class="unvalid armx - icon armx-cancel"> The Pickup branch is required please select one'
    }
    if (this.productType.toLowerCase() == "cac") {
      var address = this.pickUpBranches.filter(x => x.BranchId == this.selectedBranchId)[0].Address
      this.consigneeDetails.addressLine = address.City + " - " + address.Street + " - Building number: " + address.BuildingNumber;
      this.consigneeDetails.referance2 = this.selectedBranchId + "";
      this.validatorObject.addressLine.valid = true
    }
    const userShortCode = this.consigneeDetails.shortCode;

    this.checkRequiredField('mobile');
    this.checkRequiredField('name');
    this.checkRequiredField('attention');
    this.checkRequiredField('addressLine');
    this.checkRequiredField('email');
    this.checkRequiredField('addressLine');
    console.log('ShortCodemandatory', this.ShortCodemandatory);
    console.log('this.consigneeDetails.shortCode', this.consigneeDetails.shortCode);


    if (this.consigneeDetails.shortCode == '' || this.consigneeDetails.shortCode == undefined) {
      if (this.ShortCodemandatory) {
        this.checkRequiredField('shortCode');
      } else {
        this.validatorObject.shortCode = {
          valid: true, message: ''
        }
      }
    }else if (this.consigneeDetails.shortCode !== '' && !this.shortCodeGrayed) {
      await this.resolveShortCodeBTN();
    }
   
    
    if (this.validatorObject.mobile.valid && this.validatorObject.name.valid && this.validatorObject.addressLine.valid && this.validatorObject.attention.valid && this.validatorObject.shortCode.valid) {
      this.consigneeDetailsObject.emit(this.consigneeDetails)
      this.productTypeSelected = true;
      this.isEnableSelectServices.emit(true);
      this.isOpen = !this.isOpen;
    }
  }

  resolvePhone(phoneNumber) {
    var branchSettings = JSON.parse(sessionStorage.getItem('branchSettings'))
    var isTouchPointIntegration = branchSettings.filter(x => x.Key == 11)[0].Value;
    this.utilities.resolvePhone({
      CountryCode: this.countryCode,
      PhoneNumber: phoneNumber
    },
      (res) => {
        this.consigneeDetails.mobile = res.PhoneNumber;
        this.consigneeDetails.telephone = res.PhoneNumber;
        this.validatorObject.mobile = {
          valid: true,
          message: ''
        }

        if (isTouchPointIntegration == 'True') {
          this.utilities.getContactByPhoneNumber(res.PhoneNumber, (result) => {
            if (result.FullAddress != null && result.FirstName != null) {
              this.consigneeDetails.name = result.FirstName + ' ' + result.LastName;
              this.consigneeDetails.attention = result.FirstName + ' ' + result.LastName;
              this.consigneeDetails.addressLine = result.FullAddress.Description;
              this.focusInput();
              this.checkRequiredField('name');
              this.checkRequiredField('attention');
              this.checkRequiredField('addressLine');
              this.checkRequiredField('email');

            }
          }, (err) => {

          });
        }
      }, (err) => {
        this.validatorObject.mobile = {
          valid: false,
          message: '<i class="unvalid armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
        }

      })
  }

  change() {
    this.isEnableSelectServices.emit(false);
    this.isOpen = !this.isOpen;
  }
  ngOnInit() {
    if (this.countryType?.key == 'Saudi Arabia') {
      this.shortCodeInput()
    }else{
      this.consigneeDetails.shortCode = '';
    }
    
  }

  shortCodeInput() {
    this.utilities.getShortCodeSetting().subscribe({
      next: (res) => {
        this.shortCodeSettingresponse = res;
        console.log('short code settings', res);
        this.checkShortCodeSetting();
      },
      error: (err) => {
        console.error("Error fetching shortcode settings", err);
      }
    });
  }

  shortCodeGrayed = false;
  checkShortCodeSetting() {
    this.shortCodeSettingresponse.forEach(setting => {
      console.log(setting);
      if (setting.IsActive == true) {
          this.shortCodeGrayed = true;
      }
        if(setting.SettingId == 443 && setting.IsActive == true) {
           this.ShortCodemandatory = true;            
        }else {
          this.ShortCodemandatory = false;
            this.validatorObject.shortCode = { valid: true, message: ''
            }
        }
    });
  }

  async resolveShortCodeBTN() {

    await this.resolveShortCode();
  }


  resolveShortCode(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.utilities.resolveShortCode({
        ShortCode: this.consigneeDetails.shortCode,
        CountryCode: this.countryType?.value
      }, (res) => {
        this.consigneeDetails.destinationCity = res.AramexCity;
        this.consigneeDetails.addressLine = res.Address1 + ' ' + res.Address2;
        this.consigneeDetails.latitude = res.Latitude;
        this.consigneeDetails.longitude = res.Longitude;
        if (res.StatusCode == 200) {
          this.consigneeDetails.shortCodeActive = true
        } 
        else if (res.StatusCode != 200 && this.consigneeDetails.shortCode.trim() == '') {
          this.validatorObject.shortCode = {
            valid: true, message: ''
          }
        } else {
          this.validatorObject.shortCode = {
            valid: false,
            message: '<i class="invalid armx-icon armx-cancel"></i> ' + res.ErrorDescription,
          }
        }
        console.log('Address from short code', res.Address1);
        console.log('Short code resolved data', res);
        resolve(res);
      }, (err) => {
          this.consigneeDetails.shortCode = '';
        this.validatorObject.shortCode = {
          valid: false,
          message: '<i class="unvalid armx-icon armx-cancel"></i> ' + this.mobileErrorService.getErrorMessage(err),
        }
        console.error('Error resolving short code', err);
        reject(err);
      })
    });
  }
}
